import { filter as adfFilter } from '@atlaskit/adf-utils/traverse';
import type { DocNode } from '@atlaskit/adf-schema';

export const getEmojis = (content: DocNode) => {
	return adfFilter(content, (node) => node.type === 'emoji');
};
